import { Component, Input } from "@angular/core";
import { DefaultComponent } from "@kpx/core";
import { TranslateModule } from "@ngx-translate/core";
import { NgxLoadersCssModule } from "ngx-loaders-css";

@Component({
  selector: "app-loading",
  imports: [NgxLoadersCssModule, TranslateModule],
  templateUrl: "./loading.component.html",
  styleUrl: "./loading.component.less",
})
export class LoadingComponent extends DefaultComponent {
  @Input()
  public text: string | null;

  public constructor() {
    super();
    this.text = null;
  }
}
